function detailMessage(data, fallback) {
  const d = data && data.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || String(x)).join(' ');
  if (typeof d === 'string') return d;
  return fallback;
}

function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

function base(apiBaseUrl) {
  return String(apiBaseUrl || '').replace(/\/+$/, '');
}

export async function fetchPendingAppointmentRequests(apiBaseUrl, token) {
  const res = await fetch(`${base(apiBaseUrl)}/appointments/requests/pending`, {
    headers: authHeaders(token),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(detailMessage(data, 'Failed to load pending requests'));
  return Array.isArray(data) ? data : [];
}

export async function acceptAppointmentRequest(apiBaseUrl, token, appointmentId, body) {
  const res = await fetch(
    `${base(apiBaseUrl)}/appointments/requests/${appointmentId}/accept`,
    {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify(body),
    }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(detailMessage(data, 'Failed to accept request'));
  return data;
}

export async function declineAppointmentRequest(apiBaseUrl, token, appointmentId, reason) {
  const res = await fetch(
    `${base(apiBaseUrl)}/appointments/requests/${appointmentId}/decline`,
    {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify({ reason: reason || null }),
    }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(detailMessage(data, 'Failed to decline request'));
  return data;
}

export async function fetchZoomSessionJoinStatus(apiBaseUrl, token, sessionName, patientMrn) {
  const params = new URLSearchParams();
  if (patientMrn != null && patientMrn !== '') {
    params.set('patient_mrn', String(patientMrn));
  }
  const qs = params.toString();
  const url = `${base(apiBaseUrl)}/zoom-video/session/${encodeURIComponent(sessionName)}/status${
    qs ? `?${qs}` : ''
  }`;
  const res = await fetch(url, { headers: authHeaders(token) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(detailMessage(data, 'Failed to check join status'));
  return data;
}
